import React from 'react';
import { PropTypes } from 'prop-types';

import { Button } from '@ontruck/orc';
import FiltersBox from 'components/orders/Filters/Filters/Dates/FiltersBox';

const FilterDates = ({
  className,
  filtersOpen,
  toggleMenuHandler,
  dateLabel,
}) => (
  <div className={className}>
    <Button
      nude
      icon="arrowtip-down"
      iconPosition="right"
      skin="secondary"
      text={dateLabel}
      onClick={toggleMenuHandler}
    />

    {filtersOpen && <FiltersBox onClickOutside={toggleMenuHandler} />}
  </div>
);

FilterDates.propTypes = {
  className: PropTypes.string,
  filtersOpen: PropTypes.bool,
  toggleMenuHandler: PropTypes.func,
  dateLabel: PropTypes.string,
};

FilterDates.defaultProps = {
  className: '',
  filtersOpen: false,
  toggleMenuHandler: () => ({}),
  dateLabel: '',
};

export default FilterDates;
